export const domain = 'widget';
